const Statistics = () => import(/* webpackChunkName: "PlayerOverview" */ './containers/Statistics.vue');

export const statisticsRouting = [
    {path: '/statistics', name: 'statistic', component: Statistics},
]
